<template>
  <div class="login-header">
    <img v-if="logo" :src="logo" />
    <span v-else></span>
    <a-btn
      v-if="isAuth"
      secondary
      color="primary"
      class="font-weight-bold logout"
      @click="logout"
    >
      {{ $t('signOut') }}
    </a-btn>
  </div>
</template>
<script>
import ABtn from '@/components/ui/ABtn';
export default {
  components: {
    ABtn,
  },
  data() {
    return {
      isAuth: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    verifyAuth() {
      this.isAuth = this.$store.getters.isAuth;
    },
  },
  computed: {
    logo() {
      return this.$store.getters['visualResources/logo'];
    },
  },
  watch: {
    $route() {
      this.verifyAuth();
    },
  },
  mounted() {
    this.verifyAuth();
  },
};
</script>
